export const limitedReleasesListConstants = {
  LIMITED_RELEASES_LIST_LOADING: "LIMITED_RELEASES_LIST_LOADING",
  LIMITED_RELEASES_LIST_SUCCESS: "LIMITED_RELEASES_LIST_SUCCESS",
  LIMITED_RELEASES_LIST_FAILURE: "LIMITED_RELEASES_LIST_FAILURE",
};
